"use strict";

var _classCallCheck = require("/builds/sis-cc/.stat-suite/dotstatsuite-data-explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/builds/sis-cc/.stat-suite/dotstatsuite-data-explorer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var ArgHandler = require("./ArgHandler");
var addressConverter = require("./addressConverter");
var JSZip = require('jszip');
var Drawing = /*#__PURE__*/function () {
  function Drawing(nodeId, workbook, sheet, node, relationshipNode) {
    _classCallCheck(this, Drawing);
    this._nodeId = nodeId;
    this._workbook = workbook;
    this._sheet = sheet;
    this._node = node;
    this._relationship = relationshipNode;
    this._init(node);
  }
  return _createClass(Drawing, [{
    key: "_init",
    value: function _init(node) {
      var to = node.children[1].children;
      var from = node.children[0].children;
      var pic = node.children[2].children[0].children[0];
      if (this._relationship) {
        if (this._relationship.attributes.Type.toString().includes('/image')) {
          this.returnImage = true;

          // Basic
          this._id = node.children[2].children[1].children[0].attributes['r:embed'];
          this._name = pic.attributes.name;
          this._description = pic.attributes.descr ? pic.attributes.descr : '';
          this._title = pic.attributes.title ? pic.attributes.title : '';
          this._path = this._relationship.attributes.Target;
          this.compressedSize = this._workbook._zip.files[this._path.replace('..', 'xl')]._data.compressedSize;
          this.uncompressedSize = this._workbook._zip.files[this._path.replace('..', 'xl')]._data.uncompressedSize;

          // Position
          this.fromCol = from[0].children[0];
          this.toCol = to[0].children[0];
          this.fromRow = from[2].children[0];
          this.toRow = to[2].children[0];

          // Offset
          this.fromColOff = from[1].children[0];
          this.toColOff = to[1].children[0];
          this.fromRowOff = from[3].children[0];
          this.toRowOff = to[3].children[0];
        } else {
          this.returnImage = true;
        }
      } else {
        this.returnImage = true;
      }

      // Clear the memory
      to = null;
      from = null;
      pic = null;
    }

    /**
     * Get Drawing ID
     * @returns {String} - Drawing ID
     * @ignore
     */
  }, {
    key: "id",
    value: function id() {
      var _this = this;
      return new ArgHandler("Drawing.id").case(function () {
        return _this._id;
      }).handle(arguments);
    }

    /**
     * Set the Drawing Defined Name
     * @param newName - the new name
     * @returns {boolean} - true
     */
    /**
    * Get the Drawing Defined Name
    * @returns {String} - Drawings Name
    */
  }, {
    key: "name",
    value: function name() {
      var _this2 = this;
      return new ArgHandler("Drawing.name").case(function () {
        return _this2._name;
      }).case('string', function (newName) {
        _this2._name = newName;
        return true;
      }).handle(arguments);
    }

    /**
     * Replace the image with a new image
     * @param imagePath - Path to the new image.
     * @returns {Drawing} - drawing
     */
    /** 
    * Get the image Data from the zip
    * @returns {Object} - image data
    */
  }, {
    key: "image",
    value: function image() {
      var _this3 = this;
      return new ArgHandler("Drawing.image").case(function () {
        return _this3._workbook._zip.files[_this3._path.replace('..', 'xl')];
      }).case('blob', function (file) {
        _this3._workbook._zip.files[_this3._path.replace('..', 'xl')]._data = new JSZip().file('i', file).files.i._data;
        return _this3;
      }).handle(arguments);
    }

    /**
     * Set the Description for the Drawing
     * @param description - the new description
     * @returns {Drawing} - drawing
     */ /** 
        * Get the Description for the Drawing
        * @returns {String} - description
        */
  }, {
    key: "description",
    value: function description() {
      var _this4 = this;
      return new ArgHandler("Drawing.description").case(function () {
        return _this4._description;
      }).case('string', function (desc) {
        _this4._description = desc;
        return _this4;
      }).handle(arguments);
    }

    /**
     * Set the Title for the Drawing
     * @param newTitle - the new title for the Drawing
     * @returns {Drawing} - drawing
     */ /** 
        * Get the Title for the Drawing
        * @returns {String} - title
        */
  }, {
    key: "title",
    value: function title() {
      var _this5 = this;
      return new ArgHandler("Drawing.title").case(function () {
        return _this5._title;
      }).case('string', function (newTitle) {
        _this5._title = newTitle;
        return _this5;
      }).handle(arguments);
    }

    /**
     * Set the Image Path
     * @param path - new Path inside the xlsx file
     * @returns {Drawing} - drawing
     */ /** 
        * Get the Image Path
        * @returns {String} - path
        */
  }, {
    key: "path",
    value: function path() {
      var _this6 = this;
      return new ArgHandler("Drawing.path").case(function () {
        return _this6._path;
      }).case('string', function (path) {
        _this6._path = path;
        return _this6;
      }).handle(arguments);
    }

    /**
     * get the From data from the Drawing
     */
  }, {
    key: "from",
    value: function from() {
      var _this7 = this;
      return new ArgHandler("Drawing.from").case(function () {
        return {
          col: _this7.fromCol,
          row: _this7.fromRow,
          colOffset: _this7.fromColOff,
          rowOffset: _this7.fromRowOff
        };
      }).case('string', function (address) {
        var ref = addressConverter.fromAddress(address);
        if (ref.type !== 'cell') throw new Error('Sheet.cell: Invalid address.');
        _this7.fromCol = ref.columnNumber - 1;
        _this7.fromRow = ref.rowNumber - 1;
        _this7.fromColOff = 0;
        _this7.fromRowOff = 0;
        return _this7;
      }).handle(arguments);
    }

    /**
     * Get the To Data from the Drawing
     */
  }, {
    key: "to",
    value: function to() {
      var _this8 = this;
      return new ArgHandler("Drawing.to").case(function () {
        return {
          col: _this8.toCol,
          row: _this8.toRow,
          colOffset: _this8.toColOff,
          rowOffset: _this8.toRowOff
        };
      }).case('string', function (address) {
        var ref = addressConverter.fromAddress(address);
        if (ref.type !== 'cell') throw new Error('Sheet.cell: Invalid address.');
        _this8.toCol = ref.columnNumber;
        _this8.toRow = ref.rowNumber;
        _this8.toColOff = 0;
        _this8.toRowOff = 0;
        return _this8;
      }).handle(arguments);
    }

    /**
     * Get the image file size
     */
  }, {
    key: "size",
    value: function size() {
      var _this9 = this;
      return new ArgHandler("Drawing.size").case(function () {
        return _this9.uncompressedSize;
      }).handle(arguments);
    }

    /**
    * overrides the original values in the XML, and then return the XML objects.
    * @returns {{}} The XML nodes.
    * @ignore
    */
  }, {
    key: "toXml",
    value: function toXml() {
      if (this.returnImage) {
        this._relationship.attributes.Id = this._id;
        this._relationship.attributes.Target = this._path;
        this._node.children[1].children[0].children[0] = this.toCol;
        this._node.children[1].children[1].children[0] = this.toColOff;
        this._node.children[1].children[2].children[0] = this.toRow;
        this._node.children[1].children[3].children[0] = this.toRowOff;
        this._node.children[0].children[0].children[0] = this.fromCol;
        this._node.children[0].children[1].children[0] = this.fromColOff;
        this._node.children[0].children[2].children[0] = this.fromRow;
        this._node.children[0].children[3].children[0] = this.fromRowOff;
        this._node.children[2].children[0].children[0].attributes.name = this._name;
        this._node.children[2].children[0].children[0].attributes.descr = this._description;
        this._node.children[2].children[0].children[0].attributes.title = this._title;
      }
      return [this._node, this._relationship];
    }
  }]);
}();
module.exports = Drawing;